'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _filterShape = require('./filterShape');

var _filterShape2 = _interopRequireDefault(_filterShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchFieldShape = _react.PropTypes.shape({
  id: _react.PropTypes.string,
  hasMore: _react.PropTypes.bool,
  fieldFilters: _react.PropTypes.arrayOf(_filterShape2.default)
});

exports.default = searchFieldShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/searchFieldShape.js
// module id = 1381
// module chunks = 1